export const exterior = 'Exterior';
export const interiorFabric = 'Interior Fabric';
export const hood = 'Hood';
export const perMonthPriceInc = 'per month inc VAT';
export const perMonthPriceExc = 'per month exc VAT';
export const allPriceInc = '(All prices inc. VAT)';
export const allPriceExc = '(All prices exc. VAT)';
export const initialPaymentPriceInc =
  'How much? (initial payment in £ inc VAT)';
export const initialPaymentPriceExc =
  'How much? (initial payment in £ exc VAT)';
export const businessContractHire = 'BCH';
export const personalContractHire = 'PCH';
export const siteWidePersonalBusinessToggleSelector = 'PersonalBusinessToggle';
export const cookieName = 'usageType';
export const contractTypeQueryStringName = 'contract_type';
export const getNonQuotableButton = (make: string) => `View all ${make} deals`;
